import { ThumbDownOffAlt, ThumbUpOffAlt } from '@mui/icons-material'
import { Box, IconButton, useTheme } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { AppDispatch } from '../../../../../store'
import { GrantMatchActions } from '../../../../../store/grantMatcher'

export const LikeDislikeWidget: FC<{
  like: Number
  handleLikeDislike: (body:any) => Promise<void>
}> = ({ like, handleLikeDislike}) => {
  const theme = useTheme()

  const [currentLikedValue, setCurrentLikedValue] = useState(like)

  useEffect(() => {
    setCurrentLikedValue(like)
  }, [like])

  const likeDislikeAction = async (newLikedValue: number, status: string) => {
    const bodyPayload = {
      like: 0,
      status: 'recommended',
      fundingAmount: '',
    }

    if (currentLikedValue !== newLikedValue) {
      bodyPayload.like = newLikedValue
      bodyPayload.status = status
      bodyPayload.fundingAmount = status === 'selected' ? '0' : ''
    }

    setCurrentLikedValue(bodyPayload.like)

    await handleLikeDislike(bodyPayload)

    setCurrentLikedValue(like)
  }

  return (
    <Box
      sx={{
        [theme.breakpoints.down('sm')]: {
          display: 'none',
        },
      }}
    >
      <IconButton
        onClick={(e) => {
          e.stopPropagation()
          likeDislikeAction(-1, 'rejected')
        }}
        sx={{ color: currentLikedValue === -1 ? 'error.main' : '' }}
      >
        <ThumbDownOffAlt />
      </IconButton>
      <IconButton
        onClick={(e) => {
          e.stopPropagation()
          likeDislikeAction(1, 'selected')
        }}
        sx={{ color: currentLikedValue === 1 ? 'primary.main' : '' }}
      >
        <ThumbUpOffAlt />
      </IconButton>
    </Box>
  )
}
